const defaultContactOptions = {
    'contact-me': true,
    'schedule-viewing': false,
    'exact-location': false,
    'more-photos': false,
    'remote-viewing': false,
    'make-offer': false,
    'text': false,
};

export {
    defaultContactOptions,
};
